import React from 'react'
import Booking from '../../../../assets/premium/icon-booking-white.svg'
import { theme } from '../../../../theme'
import IconBackground from './IconBackground'

function BookingIcon({ size = 1, color = theme.colors.palette.booking }) {
  return (
    <IconBackground size={size} color={color}>
      <img
        alt={'bedbooking icon'}
        style={{ color: 'white' }}
        width={16 * size}
        height={16 * size}
        src={Booking}
      />
    </IconBackground>
  )
}

export default BookingIcon
